//------------------------------------------------------------------------------
// 画面設定 アクション
//------------------------------------------------------------------------------
import types from './types';

/**
 * 地図マウスホイール設定 (ホイールで拡大/縮小)
 */
export const setWheelZoom = (wheelZoom) => {
  return {
    type: types.WHEEL_ZOOM,
    wheelZoom,
  };
};

/**
 * 地図アクション表示設定
 */
export const setMapConfig = (mapConfig) => {
  return {
    type: types.MAP_CONFIG,
    mapConfig,
  };
};
